<template>
  <div class="flex flex-col items-center bg-light-bg dark:bg-dark-bg min-h-screen text-light-text dark:text-dark-text">
    <AppSidebar />

    <div class="w-full max-w-4xl bg-white dark:bg-dark-box-bg rounded-lg shadow-md p-6 mt-6">
      <button
          @click="goToBack"
          class="mb-4 text-blue-600 dark:text-blue-400 hover:underline flex items-center"
      >
        &larr; Wróć do poprzedniej strony
      </button>

      <div v-if="dispatcher">
        <h2 class="text-2xl font-bold mb-6">Profil Dyspozytora</h2>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
          <div>
            <p><strong>Imię i nazwisko:</strong> {{ dispatcher?.firstName || 'Brak imienia' }} {{ dispatcher?.lastName || 'Brak nazwiska' }}</p>
            <p><strong>ID:</strong> {{ dispatcher?.id || 'Brak ID' }}</p>
            <p><strong>Telefon:</strong> {{ dispatcher?.phone || 'Brak telefonu' }}</p>
          </div>
          <div>
            <p><strong>Nazwa użytkownika:</strong> {{ dispatcher?.username || 'Brak nazwy' }}</p>
            <p><strong>Rola:</strong> {{ getRoleInPolish(dispatcher?.role.name) || 'Brak Roli' }}</p>
          </div>
        </div>

        <hr class="my-6 border-light-border dark:border-dark-border">

        <button
            v-if="this.user.role === 'ROLE_ADMIN'"
            @click="showModal = true"
            class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Zmień hasło użytkownika
        </button>
      </div>

      <!-- Loading State -->
      <div v-else-if="loading" class="text-gray-500 dark:text-gray-400">
        <p>Ładowanie szczegółów dyspozytora...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="errorMessage" class="text-red-500 dark:text-red-400">
        <p>{{ errorMessage }}</p>
      </div>

      <!-- Modal -->
      <div v-if="showModal" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div class="bg-white dark:bg-dark-box-bg rounded-lg shadow-lg p-6 w-96">
          <h3 class="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Zmień hasło użytkownika</h3>
          <input
              v-model="newPassword"
              type="password"
              placeholder="Nowe hasło"
              class="w-full mb-4 p-2 border rounded-lg dark:bg-gray-900 dark:text-gray-100"
          />
          <div class="flex justify-end">
            <button
                @click="showModal = false"
                class="mr-2 px-4 py-2 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition-colors"
            >
              Anuluj
            </button>
            <button
                @click="changePassword"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Zapisz
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { useAuthStore } from '@/stores/authStore';
import dispatcherService from '@/services/dispatchersService';
import AppSidebar from "@/components/AppSidebar.vue";
import settingsService from '@/services/settingsService';
import { RoleMap } from '../utils/roleMap';

export default {
  name: 'DispatcherProfile',
  components: { AppSidebar },
  data() {
    return {
      dispatcher: null,
      loading: true,
      errorMessage: '',
      showModal: false,
      newPassword: '', // Przechowuje nowe hasło wpisane przez administratora
    };
  },
  setup() {
    const authStore = useAuthStore();
    authStore.checkExpiration();
    return { user: authStore.user };
  },
  mounted() {
    this.fetchDispatcher();
  },
  methods: {
    async fetchDispatcher() {
      const dispatcherId = this.$route.params.id;
      try {
        const response = await dispatcherService.getDispatcherById(dispatcherId);
        this.dispatcher = response.data;
        this.loading = false;
      } catch (error) {
        this.errorMessage = 'Błąd podczas pobierania szczegółów dyspozytora. Spróbuj ponownie.';
        this.loading = false;
      }
    },
    goToBack() {
      const returnTo = this.$route.query.returnTo;
      const currentPage = this.$route.query.currentPage;

      if (returnTo) {
        this.$router.push({ 
          name: returnTo,
          query: {currentPage: currentPage} 
        });
      } else {
        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({
            name: 'DispatchersPageAdmin',
            query: {currentPage: currentPage} 
          });
        } else {
          this.$router.push({
            name: 'DashboardPageDispatcher',
            query: {currentPage: currentPage} 
          });
        }
      }
    },
    getRoleInPolish(role) {
      return RoleMap[role] || 'Nieznana rola';
    },
    async changePassword() {
      if (!this.newPassword) {
        alert('Podaj nowe hasło!');
        return;
      }
      try {
        await settingsService.adminChangePassword(this.dispatcher.id, this.newPassword);
        alert('Hasło zostało pomyślnie zmienione!');
        this.showModal = false;
        this.newPassword = '';
      } catch (error) {
        alert('Wystąpił błąd podczas zmiany hasła. Spróbuj ponownie.');
      }
    },
  }
};
</script>
